exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1cqMEb6Nmd-UHuVoCk57Qa{display:inline-block}html[dir=ltr] ._1cqMEb6Nmd-UHuVoCk57Qa{margin-right:12px}html[dir=rtl] ._1cqMEb6Nmd-UHuVoCk57Qa{margin-left:12px}._1qXrEYZzHCbMex3bbE3CvI{width:138px;height:32px}html[dir] ._1qXrEYZzHCbMex3bbE3CvI,html[dir] ._1qXrEYZzHCbMex3bbE3CvI:hover{border:none}._8kJ5KY-uG4I1byMg7S8cG{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0)}html[dir] ._8kJ5KY-uG4I1byMg7S8cG{padding:0;margin:-1px;border:0}", ""]);
// Exports
exports.locals = {
	"shareLinkAttach": "_1cqMEb6Nmd-UHuVoCk57Qa",
	"primaryOption": "_1qXrEYZzHCbMex3bbE3CvI",
	"splitButtonAriaDescription": "_8kJ5KY-uG4I1byMg7S8cG"
};